/**
 * Get the CSRF token from the head attribute csrf-token
 * 
 * @returns {string} The CSRF token
 */
export function getCRSFToken() {
    // Get from head attribute csrf-token
    return document.head.querySelector('meta[name="csrf-token"]').content;
}

/**
 * Test the API token
 * @param {string} token - The API token
 * @returns {Promise<Response>} The response from the API
 */
export function testAPIToken(token) {
    return fetch('/api/test', {
        method: "GET",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
    });
}

/**
 * Get the Laravel user API token from the window.Laravel object
 * @returns {string} The Laravel user API token
 */
function getLaravelUserApiToken() {
    if (window.Laravel) {
        return window.Laravel?.apiToken || null;
    } else {
        console.warn('Laravel not found!');
    }

    return null;
}

/**
 * Get the token from the useToken hook
 * @returns {Object} The token object
 */
export function useToken() {
    return {
        token: getLaravelUserApiToken(),
        csrfToken: getCRSFToken()
    }
}